import React, { useEffect, useState } from "react";
import { EditButton } from "../buttons/button";
import "./layout.css";
import { PagLeftIcon } from "../../assets/icons/arrow-pagination-icons";
import { useNavigate } from "react-router-dom";
import { formatString } from "../helper-components/helper-function";
import CalendorIcon from "../../assets/icons/calendor-icon";
import TimerIcon from "../../assets/icons/timer-icon";
import PersonIcon from "../../assets/icons/person-icon";
import { ChevronDown } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PERIOD_OPTIONS = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Yearly", value: "yearly" },
  { label: "Custom", value: "custom_date" },
];

const InnerLayout = (props) => {
  const navigate = useNavigate();
  const defaultPermissionFn = () => { };
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [period, setPeriod] = useState("yearly");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setCurrentDate(
        now.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "2-digit",
        })
      );
      setCurrentTime(
        now.toLocaleTimeString("en-US", {
          hour12: true,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    };

    updateDateTime(); // Initialize immediately
    const intervalId = setInterval(updateDateTime, 1000); // Update time every second

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (props.showDashboardFilters && props.onPeriodChange) {
      props.onPeriodChange({ period, fromDate, toDate });
    }
  }, [period, fromDate, toDate]);

  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".main-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <div className="flex flex-col h-full w-full overflow-y-hidden">
      <div className="inner_layout_header main-div  flex justify-between w-[-webkit-fill-available]">
        <div className="flex items-center gap-2">
          {props?.backBtn && (
            <button
              onClick={() => {
                if (props?.title === "Past Orders") {
                  navigate(`/add-invoice?phoneNumber=${props?.phoneNumber}`);
                } else {
                  navigate(-1);
                }
              }}
            >
              <PagLeftIcon
                width="20px"
                height="20px"
                fill="var(--heading-color)"
              />
            </button>
          )}
          <span className="text-[var(--top-nav-heading-color)] text-[length:--top-nav-heading-size] font-[var(--top-nav-heading-weight)]">
            {props?.title}
          </span>
        </div>
        <div className="flex gap-3 text-sm items-center">
          {props.showDashboardFilters && (
            <div className="flex gap-3 items-center">
              <div className="relative">
                <button
                  className="flex items-center justify-between px-2 py-2 border border-[#E5E7EB] rounded-lg bg-white min-w-[140px] text-[#475569] font-medium focus:outline-none"
                  onClick={() => setShowPeriodDropdown((v) => !v)}
                  type="button"
                >
                  <span className="flex items-center gap-2">
                    <CalendorIcon />
                    <span>
                      {PERIOD_OPTIONS.find((opt) => opt.value === period)
                        ?.label || "Custom"}
                    </span>
                  </span>
                  <ChevronDown size={18} />
                </button>
                {showPeriodDropdown && (
                  <div className="absolute left-0 mt-2 w-full bg-white border border-[#E5E7EB] rounded-lg shadow z-50">
                    {PERIOD_OPTIONS.map((opt) => (
                      <div
                        key={opt.value}
                        className={`px-4 py-2 cursor-pointer hover:bg-[#F1F5F9] ${period === opt.value
                          ? "bg-[#F1F5F9] font-semibold"
                          : ""
                          }`}
                        onClick={() => {
                          setPeriod(opt.value);
                          setShowPeriodDropdown(false);
                        }}
                      >
                        {opt.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {period === "custom_date" && (
                <div
                  style={{
                    height: "32px",
                    width: "150px",
                  }}
                  className="flex items-center border border-[#E5E7EB] rounded-md gap-[8px] px-2 z-20"
                >
                  <CalendorIcon width="14px" height="14px" />
                  <DatePicker
                    selected={fromDate ? new Date(fromDate) : null}
                    onChange={(date) =>
                      setFromDate(date ? date.toLocaleDateString('en-CA') : "")
                    }
                    selectsStart
                    startDate={fromDate ? new Date(fromDate) : null}
                    endDate={toDate ? new Date(toDate) : null}
                    placeholderText="From Date"
                    className="w-full bg-transparent focus:outline-none text-[var(--head-input-fg-color)] text-[length:var(--head-input-font-size)] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:var(--head-input-font-size)] placeholder:font-[var(--head-input-place-font-weight)]"
                    dateFormat="yyyy-MM-dd"
                    isClearable
                  />
                </div>
              )}
              {period === "custom_date" && (
                <div
                  style={{
                    height: "32px",
                    width: "150px",
                  }}
                  className="flex items-center border border-[#E5E7EB] rounded-md gap-[8px] px-2 z-20"
                >
                  <CalendorIcon width="14px" height="14px" />
                  <DatePicker
                    selected={toDate ? new Date(toDate) : null}
                    onChange={(date) =>
                      setToDate(date ? date.toLocaleDateString('en-CA') : "")
                    }
                    selectsEnd
                    startDate={fromDate ? new Date(fromDate) : null}
                    endDate={toDate ? new Date(toDate) : null}
                    minDate={fromDate ? new Date(fromDate) : null}
                    placeholderText="To Date"
                    className="w-full bg-transparent focus:outline-none text-[var(--head-input-fg-color)] text-[length:var(--head-input-font-size)] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:var(--head-input-font-size)] placeholder:font-[var(--head-input-place-font-weight)]"
                    dateFormat="yyyy-MM-dd"
                    isClearable
                  />
                </div>
              )}
            </div>
          )}
          <span className="text-FFBA08 text-sm">{props?.title1}</span>
          <div
            style={{
              width: "15rem",
            }}
            className="text-[var(--top-nav-text-color)] text-[length:--top-nav-text-size] font-[var(--top-nav-text-weight)] whitespace-nowrap flex gap-5 items-center  border-r-[var(--top-nav-border-color)] border-r"
          >
            <span className="flex gap-2 items-center">
              <CalendorIcon /> {currentDate}
            </span>{" "}
            <span className="flex gap-2 items-center">
              <TimerIcon />
              {currentTime}
            </span>
          </div>
          {props.view &&
            (props?.permissionFn || defaultPermissionFn)(props?.module)
              ?.update && (
              <EditButton onclkFn={props?.onclkEditFn} text="Edit" />
            )}
          <span className="text-[var(--top-nav-heading-color)] text-[length:--top-nav-text-size] font-[var(--top-nav-text-weight)] flex items-center gap-2">
            {" "}
            <PersonIcon />{" "}
            {formatString(localStorage.getItem("user_name") || "")}
          </span>
        </div>
      </div>
      <div
        style={{
          height: `calc(100% - ${heightOfFirstDiv}px)`,
        }}
        className={`innerLayoutScroller ${props?.list ? "" : "overflow-y-auto"
          }`}
      >
        {props?.children}
      </div>
    </div>
  );
};

export default InnerLayout;
